export enum SubNavigationType {
    WebServiceControl = 1,
    ConfigSettings = 2,
    PaymentOptions = 3,
    EngagementOptions = 4,
}
